import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import { faPlusCircle, faSyncAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";

import * as DevelopersActions from "../../../middleware/Store/Actions/DevelopersActions";
import * as ContactsActions from "../../../middleware/Store/Actions/ContactsActions";
import * as SandBoxAuthenticationActions from "../../../middleware/Store/Actions/SandBoxAuthenticationActions";
import * as ErrorUtils from "../../Utils/ErrorUtils";
import * as DeveloperUtils from "../../Utils/DeveloperUtils";
import * as DeveloperConstant from "../../Constants/DeveloperConstant";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SANDBOX_STATUS";
const CREATE_SANDBOX_TIMEOUT = 3000;

const SandBoxStatus = (props) => {
    const intl = useIntl();
    const [sandBoxStatus, setSandBoxStatus] = useState(DeveloperUtils.getSandBoxStatus(props.user));
    const [progress, setProgress] = useState(false);
    const [statusProgress, setStatusProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        LogService.trace(LOG_TAG, "use effect user")
        if (props.user) {
            setSandBoxStatus(DeveloperUtils.getSandBoxStatus(props.user));
        }
    }, [props.user]);

    const handleSanboxCreate = () => {
        LogService.trace(LOG_TAG, "handleSandBoxCreate");

        setProgress(true);
        setSandBoxStatus(DeveloperConstant.SandBoxState.PENDING);
        props.createSandBox()
            .then((data) => {
                LogService.info(LOG_TAG, "handleSandBoxCreate success", data);
                setErrorMessage("");
                setTimeout(() => {
                    LogService.info(LOG_TAG, "handleSandBoxCreate refresh user informations");
                    props.getUserContact()
                        .then(user => props.getSandBoxBaseServerUrl(user))
                        .then(() => {
                            setProgress(false);
                        })
                        .catch(errorPayload => {
                            setProgress(false);
                            setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
                        });
                }, CREATE_SANDBOX_TIMEOUT);
            })
            .catch((errorPayload) => {
                LogService.info(LOG_TAG, "handleSandBoxCreate error");
                setProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
                props.getUserContact();
            });
    }

    const handleStatusRefresh = () => {
        LogService.trace(LOG_TAG, "handleStatusRefresh");

        if (statusProgress === true)
            return;

        setStatusProgress(true);
        setSandBoxStatus(DeveloperConstant.SandBoxState.PENDING);
        props.getUserContact()
            .then(user => props.getSandBoxBaseServerUrl(user))
            .then(() => {
                LogService.info(LOG_TAG, "handleStatusRefresh success");
                setStatusProgress(false);
            })
            .catch((errorPayload) => {
                LogService.info(LOG_TAG, "handleStatusRefresh error");
                setStatusProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
            });
    }

    LogService.trace(LOG_TAG, "render");

    let footer = null;
    let message = null;
    if (sandBoxStatus === DeveloperConstant.SandBoxState.FAILED || sandBoxStatus === DeveloperConstant.SandBoxState.NONE) {
        message = <div id="messageId" className="panel bg-fog mb-3">{intl.messages.sandBoxSatusCreateMessage}</div>
        footer =
            <div className="mt-2">
                <Button
                    id="createButton"
                    label={intl.messages.sandBoxStatusCreateButton}
                    icon={faPlusCircle}
                    className="btn-submit d-block mt-2"
                    onClick={handleSanboxCreate}
                    spinner={progress}
                    disabled={progress}
                />
                {
                    (errorMessage) &&
                    <ErrorPanel id="option-error" size={ErrorSize.Small}>{errorMessage}</ErrorPanel>
                }
            </div>;
    } else if (sandBoxStatus === DeveloperConstant.SandBoxState.SUCCESS) {
        const sandBoxUrl = DeveloperUtils.getWebClientSandBoxUrl(props.sandBoxBaseServerUrl)
        message =
            <div id="messageId" className="panel bg-fog mb-3">
                {intl.messages.sandBoxStatusUrlMessage}
                <br />

                <a href={sandBoxUrl.toString()} target="_blank" rel="noopener noreferrer" className="btn-link-green">
                    <FontAwesomeIcon icon={faArrowRight} className="mr-1" />{sandBoxUrl.hostname}</a>
            </div>
    }

    return (
        <Card title={intl.messages.sandBoxStatusTitle}
            icon={faSyncAlt}
            label={intl.messages.refresh}
            spinner={statusProgress}
            onClick={handleStatusRefresh}
        >
            <table className="table">
                <tbody>
                    <tr>
                        <td className="table-label">{intl.messages.sandBoxStatusState}</td>
                        <td id="statusId" className="text-right"><span className={"badge-dashed " + sandBoxStatus} >{DeveloperUtils.getSandBoxStatusValueToDisplay(sandBoxStatus)}</span></td>
                    </tr>
                </tbody>
            </table>
            {message}
            {footer}
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        applications: state.applications.applications,
        sandBoxBaseServerUrl: state.sandBoxAuthentication.account.baseServerUrl
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createSandBox: () => dispatch(DevelopersActions.createSandBoxAdminAccount()),
        getUserContact: () => dispatch(ContactsActions.getUserContact(false)),
        getSandBoxBaseServerUrl: (user) => dispatch(SandBoxAuthenticationActions.getBaseServerEnvironment(user)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SandBoxStatus);